(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bison-d2c-homepage"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.bison-compare__media video').forEach((video) => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
});
if ((window.Shopify && window.Shopify.designMode) || window.self !== window.top) {
  document.documentElement.classList.add('bison-theme-preview');
}
const markShopifyPreview = () => {
  if (!document.getElementById('PBarNextFrameWrapper')) return false;
  document.documentElement.classList.add('bison-shopify-preview');
  return true;
};
if (!markShopifyPreview()) {
  const previewObserver = new MutationObserver(() => {
    if (markShopifyPreview()) previewObserver.disconnect();
  });
  previewObserver.observe(document.documentElement, { childList: true, subtree: true });
}
document.querySelectorAll('[data-bison-sticky-shop]').forEach((sticky) => {
  const homepage = sticky.closest('.bison-editable') || document;
  const offers = homepage.querySelector('#offers');
  const howItWorks = homepage.querySelector('#how-it-works');
  const inlineShopButtons = Array.from(document.querySelectorAll('.bison-video-hero__btn--primary, .bison-compare__cta .bison-btn, .bison-how__actions--mobile .bison-btn'));
  document.body.appendChild(sticky);
  const updateSticky = () => {
    const offersReached = offers && offers.getBoundingClientRect().top <= window.innerHeight;
    const howItWorksVisible = howItWorks && (() => {
      const rect = howItWorks.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    })();
    const inlineButtonVisible = inlineShopButtons.some((button) => {
      const rect = button.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0;
    });
    sticky.classList.toggle('is-hidden', howItWorksVisible || inlineButtonVisible || offersReached);
  };
  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);
  updateSticky();
});
document.querySelectorAll('[data-bison-speed-toggle]').forEach((button) => {
  const video = button.closest('.bison-compare__media')?.querySelector('video');
  if (!video) return;
  const elapsed = video.parentElement.querySelector('[data-bison-elapsed]');
  const updateElapsed = () => {
    if (!elapsed || !video.duration) return;
    const sourceSeconds = Number(video.dataset.sourceSeconds || video.duration);
    const playbackSeconds = Number(video.dataset.timedPlaybackSeconds || video.duration);
    const seconds = Math.min(sourceSeconds, Math.round((video.currentTime / playbackSeconds) * sourceSeconds));
    elapsed.textContent = `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
  };
  video.addEventListener('timeupdate', updateElapsed);
  video.addEventListener('loadedmetadata', updateElapsed);
  button.addEventListener('click', () => {
    const regular = video.dataset.mode !== 'regular';
    const oldPlaybackSeconds = Number(video.dataset.timedPlaybackSeconds || video.duration || 1);
    const sourceMoment = (video.currentTime / oldPlaybackSeconds) * 60;
    const newPlaybackSeconds = regular ? 67 : 8.375;
    const resumeAt = Math.min(newPlaybackSeconds - 0.05, (sourceMoment / 60) * newPlaybackSeconds);
    const wasPlaying = !video.paused;
    video.dataset.mode = regular ? 'regular' : 'fast';
    video.src = regular ? video.dataset.regularSrc : video.dataset.fastSrc;
    video.loop = !regular;
    video.dataset.sourceSeconds = '60';
    video.dataset.timedPlaybackSeconds = String(newPlaybackSeconds);
    button.querySelector('span').textContent = regular ? button.dataset.fastLabel : button.dataset.regularLabel;
    video.addEventListener('loadedmetadata', () => {
      video.currentTime = resumeAt;
      updateElapsed();
      if (wasPlaying) video.play().catch(() => {});
    }, { once: true });
    video.load();
  });
});
document.querySelectorAll('[data-bison-offer-form]').forEach((wrapper) => {
  if (wrapper.dataset.ready === 'true') return;
  wrapper.dataset.ready = 'true';
  const form = wrapper.querySelector('form');
  const button = wrapper.querySelector('button[type="submit"]');
  const variantInputs = Array.from(wrapper.querySelectorAll('[data-bison-offer-variant]'));
  const message = wrapper.querySelector('.bison-offer__message');
  const discountCode = wrapper.dataset.bisonDiscountCode.trim();
  if (!form || !button) return;
  const updateVariantThumbnail = (input) => {
    if (input.tagName !== 'SELECT') return;
    const field = input.closest('.bison-offer__variant-field');
    const selectedOption = input.options[input.selectedIndex];
    const thumbnail = field?.querySelector('[data-bison-variant-thumb]');
    const label = field?.querySelector('[data-bison-variant-label]');
    const image = selectedOption?.dataset.image;
    if (thumbnail && image) thumbnail.src = image;
    if (label) label.textContent = selectedOption?.dataset.title || selectedOption?.textContent || '';
    field?.querySelectorAll('[data-bison-variant-choice]').forEach((choice) => {
      const selected = choice.dataset.bisonVariantChoice === input.value;
      choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
      choice.tabIndex = selected ? 0 : -1;
    });
  };
  const updateAvailability = () => {
    variantInputs.forEach(updateVariantThumbnail);
    button.disabled = variantInputs.some((input) => input.tagName === 'SELECT' && input.options[input.selectedIndex]?.dataset.available !== 'true');
    message.textContent = '';
  };
  wrapper.querySelectorAll('[data-bison-variant-choice]').forEach((choice) => {
    choice.addEventListener('click', () => {
      const field = choice.closest('.bison-offer__variant-field');
      const select = field?.querySelector('[data-bison-offer-variant]');
      if (!select || choice.disabled) return;
      select.value = choice.dataset.bisonVariantChoice;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      const disclosure = field.querySelector('[data-bison-color-select]');
      if (disclosure) {
        disclosure.open = false;
        disclosure.querySelector('summary')?.focus();
      }
    });
  });
  wrapper.querySelectorAll('[data-bison-color-select]').forEach((disclosure) => {
    const summary = disclosure.querySelector('summary');
    const choices = Array.from(disclosure.querySelectorAll('[data-bison-variant-choice]'));
    const enabledChoices = () => choices.filter((choice) => !choice.disabled);
    const focusChoice = (position) => {
      const enabled = enabledChoices();
      if (!enabled.length) return;
      enabled[Math.max(0, Math.min(position, enabled.length - 1))].focus();
    };
    disclosure.addEventListener('toggle', () => {
      if (disclosure.open) {
        document.querySelectorAll('[data-bison-color-select][open]').forEach((other) => {
          if (other !== disclosure) other.open = false;
        });
      }
    });
    summary?.addEventListener('keydown', (event) => {
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End', 'Escape'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Escape') {
        disclosure.open = false;
        return;
      }
      disclosure.open = true;
      const enabled = enabledChoices();
      const selectedIndex = enabled.findIndex((choice) => choice.getAttribute('aria-pressed') === 'true');
      const position = event.key === 'End' ? enabled.length - 1 : event.key === 'ArrowUp' ? Math.max(0, selectedIndex < 0 ? enabled.length - 1 : selectedIndex) : event.key === 'Home' ? 0 : Math.max(0, selectedIndex);
      requestAnimationFrame(() => focusChoice(position));
    });
    choices.forEach((choice) => {
      choice.addEventListener('keydown', (event) => {
        const enabled = enabledChoices();
        const current = enabled.indexOf(choice);
        let next = current;
        if (event.key === 'ArrowDown') next = (current + 1) % enabled.length;
        else if (event.key === 'ArrowUp') next = (current - 1 + enabled.length) % enabled.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = enabled.length - 1;
        else if (event.key === 'Escape') {
          event.preventDefault();
          disclosure.open = false;
          summary?.focus();
          return;
        } else return;
        event.preventDefault();
        focusChoice(next);
      });
    });
    document.addEventListener('click', (event) => {
      if (disclosure.open && !disclosure.contains(event.target)) disclosure.open = false;
    });
  });
  variantInputs.forEach((input) => input.addEventListener('change', updateAvailability));
  updateAvailability();
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (button.disabled) return;
    button.disabled = true;
    button.classList.add('is-loading');
    message.textContent = '';
    try {
      const itemQuantities = new Map();
      if (variantInputs.length === 1 && variantInputs[0].tagName === 'INPUT') {
        itemQuantities.set(variantInputs[0].value, Number(form.elements.quantity.value));
      } else {
        variantInputs.forEach((input) => {
          itemQuantities.set(input.value, (itemQuantities.get(input.value) || 0) + 1);
        });
      }
      const items = Array.from(itemQuantities, ([id, quantity]) => ({ id: Number(id), quantity }));
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items })
      });
      const product = await response.json();
      if (!response.ok) throw product;
      if (discountCode) {
        await fetch(`${window.Shopify.routes.root}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(window.Shopify.routes.root + 'cart')}`, {
          credentials: 'same-origin'
        });
      }
      form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: { product, addToCartBtn: button }
      }));
    } catch (error) {
      message.textContent = error.description || error.message || String(error);
      message.setAttribute('role', 'alert');
    } finally {
      button.classList.remove('is-loading');
      updateAvailability();
    }
  });
});

document.querySelectorAll('[data-bison-testimonials]').forEach((carousel) => {
  if (carousel.dataset.ready === 'true') return;
  carousel.dataset.ready = 'true';
  const viewport = carousel.querySelector('[data-testimonial-viewport]');
  const track = carousel.querySelector('[data-testimonial-track]');
  const originals = Array.from(carousel.querySelectorAll('[data-testimonial-card]'));
  const status = carousel.querySelector('[data-testimonial-status]');
  if (!viewport || !track || originals.length === 0) return;
  const cloneCount = Math.min(3, originals.length);
  originals.forEach((card, index) => { card.dataset.testimonialIndex = index; });
  const prepareClone = (card) => {
    const clone = card.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('data-shopify-editor-block');
    clone.querySelectorAll('[id]').forEach((item) => item.removeAttribute('id'));
    return clone;
  };
  originals.slice(-cloneCount).reverse().forEach((card) => track.prepend(prepareClone(card)));
  originals.slice(0, cloneCount).forEach((card) => track.append(prepareClone(card)));
  let cards = Array.from(track.querySelectorAll('[data-testimonial-card]'));
  let physicalIndex = cloneCount;
  let moving = false;
  let moveTimer;
  const centerCard = (animate = true) => {
    track.classList.toggle('is-resetting', !animate);
    cards.forEach((card, index) => {
      const active = index === physicalIndex;
      card.classList.toggle('is-active', active);
      card.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    const card = cards[physicalIndex];
    const offset = viewport.clientWidth / 2 - card.offsetLeft - card.offsetWidth / 2;
    track.style.transform = `translate3d(${offset}px,0,0)`;
    const originalIndex = Number(card.dataset.testimonialIndex);
    status.textContent = `${originalIndex + 1} of ${originals.length}`;
    if (!animate) requestAnimationFrame(() => track.classList.remove('is-resetting'));
  };
  const finishMove = () => {
    clearTimeout(moveTimer);
    if (physicalIndex >= cloneCount + originals.length) physicalIndex = cloneCount;
    if (physicalIndex < cloneCount) physicalIndex = cloneCount + originals.length - 1;
    centerCard(false);
    moving = false;
  };
  const move = (direction) => {
    if (moving || originals.length < 2) return;
    moving = true;
    physicalIndex += direction;
    centerCard(true);
    // Reduced motion disables transitions, so transitionend may never fire.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finishMove();
    else moveTimer = setTimeout(finishMove, 500);
  };
  track.addEventListener('transitionend', (event) => {
    if (event.target !== track || event.propertyName !== 'transform') return;
    finishMove();
  });
  let gesture = null;
  viewport.addEventListener('touchstart', (event) => {
    gesture = event.touches.length === 1 && !moving
      ? { x: event.touches[0].clientX, y: event.touches[0].clientY, axis: null }
      : null;
  }, { passive: true });
  viewport.addEventListener('touchmove', (event) => {
    if (!gesture) return;
    if (event.touches.length !== 1) {
      gesture = null;
      return;
    }
    const dx = event.touches[0].clientX - gesture.x;
    const dy = event.touches[0].clientY - gesture.y;
    if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) >= 8) {
      if (Math.abs(dx) > Math.abs(dy) * 1.2) gesture.axis = 'horizontal';
      else if (Math.abs(dy) >= Math.abs(dx)) gesture.axis = 'vertical';
    }
    if (gesture.axis === 'horizontal' && event.cancelable) event.preventDefault();
  }, { passive: false });
  viewport.addEventListener('touchend', (event) => {
    const completed = gesture;
    gesture = null;
    if (!completed || completed.axis !== 'horizontal' || event.touches.length) return;
    // Avoid activating a card or link when finishing a horizontal gesture.
    if (event.cancelable) event.preventDefault();
    const touch = event.changedTouches[0];
    if (!touch) return;
    const dx = touch.clientX - completed.x;
    const dy = touch.clientY - completed.y;
    if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
      move(dx < 0 ? 1 : -1);
    }
  }, { passive: false });
  viewport.addEventListener('touchcancel', () => { gesture = null; }, { passive: true });
  carousel.querySelector('[data-testimonial-prev]')?.addEventListener('click', () => move(-1));
  carousel.querySelector('[data-testimonial-next]')?.addEventListener('click', () => move(1));
  cards.forEach((card, index) => card.addEventListener('click', () => {
    if (index === physicalIndex) return;
    physicalIndex = index;
    centerCard(true);
  }));
  window.addEventListener('resize', () => centerCard(false));
  centerCard(false);
});

document.querySelectorAll('[data-bison-open-reviews]').forEach((link) => {
  link.addEventListener('click', (event) => {
    const reviewsButton = document.querySelector('#AirReviews-FloatButtonWrapper .AirReviews-Widget__FloatButton');
    if (!reviewsButton) return;
    event.preventDefault();
    reviewsButton.click();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bison-neighbors-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.bnl-hero video').forEach((video) => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    video.pause();
    video.removeAttribute('autoplay');
  }
});


const bnlDemoVideoObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting && !entry.target.paused) entry.target.pause();
  });
}, { threshold: 0.15 });

document.querySelectorAll('.bnl-video-slide video').forEach((video) => {
  bnlDemoVideoObserver.observe(video);
});

document.querySelectorAll('[data-bnl-video-carousel]').forEach((carousel) => {
  const tabs = Array.from(carousel.querySelectorAll('[data-bnl-video-tab]'));
  const slides = Array.from(carousel.querySelectorAll('.bnl-video-slide'));
  let active = 0;
  const show = (index, shouldPlay = true) => {
    active = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      const selected = i === active;
      slide.hidden = !selected;
      slide.classList.toggle('is-active', selected);
      const video = slide.querySelector('video');
      if (!video) return;
      if (!selected) {
        video.pause();
      } else if (shouldPlay) {
        video.play().catch(() => {});
      }
    });
    tabs.forEach((tab, i) => {
      const selected = i === active;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });
  };
  carousel.addEventListener('bison:video-reveal', event => {
    const index = slides.indexOf(event.detail.slide);
    if (index >= 0) show(index, false);
  });
  tabs.forEach((tab, index) => tab.addEventListener('click', () => show(index)));
  carousel.querySelector('[data-bnl-video-prev]')?.addEventListener('click', () => show(active - 1));
  carousel.querySelector('[data-bnl-video-next]')?.addEventListener('click', () => show(active + 1));
  carousel.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    show(active + (event.key === 'ArrowRight' ? 1 : -1));
    tabs[active]?.focus();
  });
  show(0);
});

document.querySelectorAll('[data-bnl-testimonials]').forEach((carousel) => {
  if (carousel.dataset.ready === 'true') return;
  carousel.dataset.ready = 'true';
  const viewport = carousel.querySelector('[data-bnl-testimonial-viewport]');
  const track = carousel.querySelector('[data-bnl-testimonial-track]');
  const originals = Array.from(carousel.querySelectorAll('[data-bnl-testimonial-card]'));
  if (!viewport || !track || originals.length === 0) return;
  const cloneCount = Math.min(3, originals.length);
  originals.forEach((card, index) => { card.dataset.testimonialIndex = index; });
  const prepareClone = (card) => {
    const clone = card.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('data-shopify-editor-block');
    clone.querySelectorAll('[id]').forEach((item) => item.removeAttribute('id'));
    return clone;
  };
  originals.slice(-cloneCount).reverse().forEach((card) => track.prepend(prepareClone(card)));
  originals.slice(0, cloneCount).forEach((card) => track.append(prepareClone(card)));
  let cards = Array.from(track.querySelectorAll('[data-bnl-testimonial-card]'));
  let physicalIndex = cloneCount;
  let moving = false;
  let moveTimer;
  const centerCard = (animate = true) => {
    track.classList.toggle('is-resetting', !animate);
    cards.forEach((card, index) => {
      const active = index === physicalIndex;
      card.classList.toggle('is-active', active);
      card.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    const card = cards[physicalIndex];
    const offset = viewport.clientWidth / 2 - card.offsetLeft - card.offsetWidth / 2;
    track.style.transform = `translate3d(${offset}px,0,0)`;
    if (!animate) requestAnimationFrame(() => track.classList.remove('is-resetting'));
  };
  const finishMove = () => {
    clearTimeout(moveTimer);
    if (physicalIndex >= cloneCount + originals.length) physicalIndex = cloneCount;
    if (physicalIndex < cloneCount) physicalIndex = cloneCount + originals.length - 1;
    centerCard(false);
    moving = false;
  };
  const move = (direction) => {
    if (moving || originals.length < 2) return;
    moving = true;
    physicalIndex += direction;
    centerCard(true);
    // Reduced motion disables transitions, so transitionend may never fire.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finishMove();
    else moveTimer = setTimeout(finishMove, 500);
  };
  track.addEventListener('transitionend', (event) => {
    if (event.target !== track || event.propertyName !== 'transform') return;
    finishMove();
  });
  let gesture = null;
  viewport.addEventListener('touchstart', (event) => {
    gesture = event.touches.length === 1 && !moving
      ? { x: event.touches[0].clientX, y: event.touches[0].clientY, axis: null }
      : null;
  }, { passive: true });
  viewport.addEventListener('touchmove', (event) => {
    if (!gesture) return;
    if (event.touches.length !== 1) {
      gesture = null;
      return;
    }
    const dx = event.touches[0].clientX - gesture.x;
    const dy = event.touches[0].clientY - gesture.y;
    if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) >= 8) {
      if (Math.abs(dx) > Math.abs(dy) * 1.2) gesture.axis = 'horizontal';
      else if (Math.abs(dy) >= Math.abs(dx)) gesture.axis = 'vertical';
    }
    if (gesture.axis === 'horizontal' && event.cancelable) event.preventDefault();
  }, { passive: false });
  viewport.addEventListener('touchend', (event) => {
    const completed = gesture;
    gesture = null;
    if (!completed || completed.axis !== 'horizontal' || event.touches.length) return;
    // Avoid activating a card or link when finishing a horizontal gesture.
    if (event.cancelable) event.preventDefault();
    const touch = event.changedTouches[0];
    if (!touch) return;
    const dx = touch.clientX - completed.x;
    const dy = touch.clientY - completed.y;
    if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
      move(dx < 0 ? 1 : -1);
    }
  }, { passive: false });
  viewport.addEventListener('touchcancel', () => { gesture = null; }, { passive: true });
  carousel.querySelector('[data-bnl-testimonial-prev]')?.addEventListener('click', () => move(-1));
  carousel.querySelector('[data-bnl-testimonial-next]')?.addEventListener('click', () => move(1));
  cards.forEach((card, index) => card.addEventListener('click', () => {
    if (index === physicalIndex) return;
    physicalIndex = index;
    centerCard(true);
  }));
  window.addEventListener('resize', () => centerCard(false));
  centerCard(false);
});

document.querySelectorAll('[data-bnl-live-offer]').forEach((offer) => {
  offer.querySelectorAll('[data-bnl-live-color-select]').forEach((details) => {
    const field=details.closest('.bnl-live-offer__variant-field');
    const select=field?.querySelector('[data-bnl-live-variant]');
    const thumb=details.querySelector('[data-bnl-live-thumb]');
    const label=details.querySelector('[data-bnl-live-label]');
    const sync=()=>{
      const option=select?.options[select.selectedIndex];
      if(option?.dataset.image && thumb) thumb.src=option.dataset.image;
      if(label && option) label.textContent=option.dataset.title||option.textContent;
      details.querySelectorAll('[data-bnl-live-choice]').forEach(btn=>btn.setAttribute('aria-pressed',btn.dataset.bnlLiveChoice===select?.value?'true':'false'));
    };
    details.querySelectorAll('[data-bnl-live-choice]').forEach(btn=>btn.addEventListener('click',()=>{
      if(btn.disabled||!select)return;
      select.value=btn.dataset.bnlLiveChoice;
      select.dispatchEvent(new Event('change',{bubbles:true}));
      details.open=false;
    }));
    select?.addEventListener('change',sync); sync();
  });
});

document.querySelectorAll('[data-bnl-live-offer]').forEach((wrapper) => {
  const button = wrapper.querySelector('[data-bnl-live-add]');
  const message = wrapper.querySelector('.bnl-live-offer__message');
  button?.addEventListener('click', async () => {
    button.disabled = true; message.textContent = '';
    try {
      const quantities = new Map();
      wrapper.querySelectorAll('[data-bnl-live-variant]').forEach((select) => quantities.set(select.value, (quantities.get(select.value) || 0) + 1));
      const items = Array.from(quantities, ([id, quantity]) => ({id:Number(id), quantity}));
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items})});
      const product = await response.json(); if(!response.ok) throw product;
      const code=(wrapper.dataset.discount||'').trim();
      if(code) await fetch(window.Shopify.routes.root+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(window.Shopify.routes.root+'cart'),{credentials:'same-origin'});
      button.dispatchEvent(new CustomEvent('ajaxProduct:added',{bubbles:true,detail:{product,addToCartBtn:button}}));
      message.textContent='Added to cart.';
    } catch(error) { message.textContent=error.description||error.message||String(error); }
    finally { button.disabled=false; }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bison-video-hero"] && !Shopify.designMode) return;
  try {
    
function bisonHeroHeadline(root) {
  const intro = root.querySelector('.bison-video-hero__heading-intro');
  const main = root.querySelector('.bison-video-hero__heading-main');
  if (!intro || !main) return;
  intro.style.fontSize = '.55em';
  const introWidth = intro.getBoundingClientRect().width;
  const mainWidth = main.getBoundingClientRect().width;
  if (introWidth > 0 && mainWidth > 0) {
    intro.style.fontSize = (.55 * mainWidth / introWidth) + 'em';
  }
}
function bisonHeroMotion(root) {
  bisonHeroHeadline(root);
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.querySelectorAll('video').forEach((video) => {
    if (reduceMotion) {
      video.pause();
      video.removeAttribute('autoplay');
    } else if (video.paused) {
      video.play().catch(() => {});
    }
  });
}
document.querySelectorAll('.bison-video-hero').forEach(bisonHeroMotion);
document.addEventListener('shopify:section:load', (event) => {
  const hero = event.target.querySelector('.bison-video-hero');
  if (hero) bisonHeroMotion(hero);
});
window.addEventListener('resize', () => {
  document.querySelectorAll('.bison-video-hero').forEach(bisonHeroHeadline);
});
if (document.fonts) document.fonts.ready.then(() => {
  document.querySelectorAll('.bison-video-hero').forEach(bisonHeroHeadline);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
